(function () {
  if (window.__plzShopBooted) return;
  window.__plzShopBooted = true;

  var qty = 1;
  var savedQty = 1;
  var currentPlan = 'sub';
  var planSwitchFromUser = false;
  var onceNudgeLastFocus = null;

  function setQty(nextQty, options) {
    var opts = options || {};
    qty = Math.max(1, nextQty);
    if (!opts.lock) savedQty = qty;
    var display = document.getElementById('plz-shop-qty-display');
    var input = document.getElementById('plz-shop-qty-input');
    if (display) display.textContent = qty;
    if (input) input.value = qty;
  }

  function setQtyLocked(locked) {
    var wrap = document.querySelector('[data-plz-qty-wrap]');
    if (!wrap) return;
    wrap.classList.toggle('is-locked', locked);
    wrap.querySelectorAll('[data-plz-qty-delta]').forEach(function (btn) {
      btn.disabled = locked;
    });
  }

  function switchPlan(type) {
    var isSub = type === 'sub';
    var isSub2 = type === 'sub2';
    var isOnce = type === 'once';
    var wasOnce = currentPlan === 'once';
    var subPanel = document.getElementById('plz-shop-plan-sub');
    var sub2Panel = document.getElementById('plz-shop-plan-sub2');
    var oncePanel = document.getElementById('plz-shop-plan-once');
    var lblSub = document.getElementById('plz-shop-lbl-sub');
    var lblSub2 = document.getElementById('plz-shop-lbl-sub2');
    var lblOnce = document.getElementById('plz-shop-lbl-once');
    var sellingPlan = document.getElementById('plz-shop-selling-plan');
    var heroPrice = document.getElementById('plz-shop-hero-price');
    var atcBtn = document.querySelector('.plz-shop-atc-btn');
    var planSub = sellingPlan ? sellingPlan.getAttribute('data-plan-sub') : '';
    var planSub2 = sellingPlan ? sellingPlan.getAttribute('data-plan-sub2') : '';
    var planSubFull = sellingPlan ? sellingPlan.getAttribute('data-plan-sub-full') : '';
    var planSub2Full = sellingPlan ? sellingPlan.getAttribute('data-plan-sub2-full') : '';
    var useFull =
      typeof window.plzHasExclusiveCoupon === 'function' && window.plzHasExclusiveCoupon();
    if (useFull) {
      if (planSubFull) planSub = planSubFull;
      if (planSub2Full) planSub2 = planSub2Full;
    }

    currentPlan = type;

    if (subPanel) subPanel.hidden = !isSub;
    if (sub2Panel) sub2Panel.hidden = !isSub2;
    if (oncePanel) oncePanel.hidden = !isOnce;

    if (lblSub) {
      lblSub.classList.toggle('is-active', isSub);
      lblSub.setAttribute('aria-checked', isSub ? 'true' : 'false');
    }
    if (lblSub2) {
      lblSub2.classList.toggle('is-active', isSub2);
      lblSub2.setAttribute('aria-checked', isSub2 ? 'true' : 'false');
    }
    if (lblOnce) {
      lblOnce.classList.toggle('is-active', isOnce);
      lblOnce.setAttribute('aria-checked', isOnce ? 'true' : 'false');
    }

    document.querySelectorAll('[data-plz-shop-plan-wrap]').forEach(function (wrap) {
      var plan = wrap.getAttribute('data-plz-shop-plan-wrap');
      wrap.classList.toggle('is-active', plan === type);
    });

    if (sellingPlan) {
      if (isSub && planSub) {
        sellingPlan.value = planSub;
        sellingPlan.disabled = false;
      } else if (isSub2 && planSub2) {
        sellingPlan.value = planSub2;
        sellingPlan.disabled = false;
      } else {
        sellingPlan.disabled = true;
      }
    }

    if (atcBtn) {
      var blockSub2 = isSub2 && !planSub2;
      atcBtn.disabled = blockSub2;
      atcBtn.title = blockSub2
        ? 'Create the Recharge plan “2 months · 2 bottles · Save 35%” to enable checkout'
        : '';
    }

    if (heroPrice) {
      var priceKey = isSub2 ? 'data-plz-price-sub2' : isSub ? 'data-plz-price-sub' : 'data-plz-price-once';
      var nextPrice = heroPrice.getAttribute(priceKey);
      if (nextPrice) heroPrice.textContent = nextPrice;
    }

    if (isSub2) {
      setQty(2, { lock: true });
      setQtyLocked(true);
    } else {
      setQtyLocked(false);
      setQty(savedQty > 0 ? savedQty : 1);
    }

    if (isOnce && planSwitchFromUser && !wasOnce) {
      openOnceNudge();
    } else if (!isOnce) {
      closeOnceNudge();
    }
  }

  function getOnceNudge() {
    return document.getElementById('plz-once-nudge');
  }

  function openOnceNudge() {
    var nudge = getOnceNudge();
    if (!nudge) return;
    onceNudgeLastFocus = document.activeElement;
    nudge.hidden = false;
    document.documentElement.classList.add('plz-once-nudge-open');
    var primary = nudge.querySelector('[data-plz-once-nudge-switch]');
    if (primary && typeof primary.focus === 'function') primary.focus();
  }

  function closeOnceNudge() {
    var nudge = getOnceNudge();
    if (!nudge || nudge.hidden) return;
    nudge.hidden = true;
    document.documentElement.classList.remove('plz-once-nudge-open');
    if (onceNudgeLastFocus && typeof onceNudgeLastFocus.focus === 'function') {
      onceNudgeLastFocus.focus();
    }
  }

  function initOnceNudge() {
    var nudge = getOnceNudge();
    if (!nudge || nudge.dataset.plzOnceNudgeInit) return;
    nudge.dataset.plzOnceNudgeInit = 'true';

    nudge.querySelectorAll('[data-plz-once-nudge-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        closeOnceNudge();
      });
    });

    var switchBtn = nudge.querySelector('[data-plz-once-nudge-switch]');
    if (switchBtn) {
      switchBtn.addEventListener('click', function () {
        var plan = nudge.getAttribute('data-switch-plan') || 'sub';
        closeOnceNudge();
        planSwitchFromUser = false;
        switchPlan(plan);
        var target = document.querySelector('[data-plz-shop-plan="' + plan + '"]');
        if (target && typeof target.focus === 'function') target.focus();
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && nudge && !nudge.hidden) {
        closeOnceNudge();
      }
    });
  }

  function changeQty(delta) {
    if (currentPlan === 'sub2') return;
    setQty(qty + delta);
  }

  function initPlanToggles() {
    var group = document.querySelector('.plz-shop-purchase__toggles[role="radiogroup"]');
    if (!group) return;

    var defaultPlan = group.getAttribute('data-plz-default-plan') || 'sub';
    if (!group.querySelector('[data-plz-shop-plan="' + defaultPlan + '"]')) {
      var first = group.querySelector('[data-plz-shop-plan]');
      defaultPlan = first ? first.getAttribute('data-plz-shop-plan') : 'once';
    }
    planSwitchFromUser = false;
    switchPlan(defaultPlan);

    group.querySelectorAll('[data-plz-shop-plan]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        planSwitchFromUser = true;
        switchPlan(btn.getAttribute('data-plz-shop-plan'));
      });

      btn.addEventListener('keydown', function (event) {
        var buttons = Array.prototype.slice.call(group.querySelectorAll('[data-plz-shop-plan]'));
        var index = buttons.indexOf(btn);
        if (index < 0) return;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          event.preventDefault();
          buttons[(index + 1) % buttons.length].focus();
          buttons[(index + 1) % buttons.length].click();
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          event.preventDefault();
          buttons[(index - 1 + buttons.length) % buttons.length].focus();
          buttons[(index - 1 + buttons.length) % buttons.length].click();
        }
      });
    });
  }

  function initQtyButtons() {
    document.querySelectorAll('[data-plz-qty-delta]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = parseInt(btn.getAttribute('data-plz-qty-delta'), 10);
        if (!isNaN(delta)) changeQty(delta);
      });
    });
  }

  function initWhySubscribeAccordion() {
    document.querySelectorAll('[data-plz-cmh-why-subscribe]').forEach(function (btn) {
      if (btn.dataset.plzWhyInit) return;
      btn.dataset.plzWhyInit = 'true';

      btn.addEventListener('click', function () {
        var wrap = btn.closest('.plz-cmh-why-subscribe');
        var panelId = btn.getAttribute('aria-controls');
        var panel = panelId ? document.getElementById(panelId) : null;
        if (!wrap || !panel) return;

        var isOpen = wrap.classList.toggle('is-open');
        panel.hidden = !isOpen;
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  }

  function initGalleryIn(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-plz-shop-gallery]:not([data-plz-gallery-init])').forEach(function (gallery) {
      gallery.dataset.plzGalleryInit = 'true';

      var track = gallery.querySelector('[data-plz-shop-gallery-track]');
      var marquee = gallery.querySelector('[data-plz-shop-gallery-marquee]');
      if (!track) return;

      var isSectionGallery = gallery.classList.contains('plz-shop-gallery--section');
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var isMobileGallery = window.matchMedia('(max-width: 900px)').matches;
      var isDesktopInput =
        window.matchMedia('(hover: hover)').matches && window.matchMedia('(pointer: fine)').matches;
      var slideRoot = marquee || track;
      var slides = slideRoot.querySelectorAll(
        '[data-plz-shop-gallery-slide]:not(.plz-shop-gallery__slide--clone)'
      );

      if (!slides.length || slides.length <= 1) return;

      if (isSectionGallery && isDesktopInput && !reducedMotion && !isMobileGallery && marquee) {
        initAutoplayGallery(gallery, track, marquee, slides);
        return;
      }

      initScrollGallery(gallery, track, track.querySelectorAll('[data-plz-shop-gallery-slide]:not(.plz-shop-gallery__slide--clone)'));
    });
  }

  function initAutoplayGallery(gallery, track, marquee, slides) {
    var isDragging = false;
    var dragStartX = 0;
    var dragStartPosition = 0;
    var dragPointerId = -1;
    var autoFrameId = 0;
    var autoPixelsPerSecond = 58;
    var lastAutoTimestamp = 0;
    var position = 0;
    var loopWidth = 0;
    var originalSlideCount = slides.length;
    var originalSlides = Array.prototype.slice.call(slides);

    function measureLoopWidth() {
      if (originalSlideCount <= 1) return 0;

      var first = originalSlides[0];
      var last = originalSlides[originalSlideCount - 1];
      if (!first || !last) return 0;

      return last.offsetLeft + last.offsetWidth - first.offsetLeft;
    }

    function normalizePosition() {
      if (!loopWidth) return;

      while (position >= loopWidth) {
        position -= loopWidth;
      }

      while (position < 0) {
        position += loopWidth;
      }
    }

    function applyTransform() {
      marquee.style.transform = 'translate3d(' + (-position) + 'px, 0, 0)';
    }

    function refreshLoopMetrics() {
      loopWidth = measureLoopWidth();
      normalizePosition();
      applyTransform();
    }

    function whenGalleryReady(callback) {
      var images = marquee.querySelectorAll('img');
      var pending = 0;
      var done = false;

      function finish() {
        if (done) return;
        done = true;
        callback();
      }

      images.forEach(function (img) {
        if (img.complete) return;
        pending += 1;
        img.addEventListener(
          'load',
          function onLoad() {
            img.removeEventListener('load', onLoad);
            pending -= 1;
            if (pending === 0) finish();
          },
          { passive: true }
        );
        img.addEventListener(
          'error',
          function onError() {
            img.removeEventListener('error', onError);
            pending -= 1;
            if (pending === 0) finish();
          },
          { passive: true }
        );
      });

      if (pending === 0) {
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(finish);
        });
      }
    }

    function setupInfiniteLoop() {
      if (originalSlideCount <= 1) return;

      function appendCloneSet() {
        originalSlides.forEach(function (slide) {
          var clone = slide.cloneNode(true);
          clone.classList.add('plz-shop-gallery__slide--clone');
          clone.setAttribute('aria-hidden', 'true');
          clone.removeAttribute('id');
          clone.querySelectorAll('img').forEach(function (img) {
            img.loading = 'eager';
          });
          marquee.appendChild(clone);
        });
      }

      appendCloneSet();
      refreshLoopMetrics();

      var minLoop = track.clientWidth * 2;
      var clonePasses = 0;
      while (loopWidth > 0 && loopWidth < minLoop && clonePasses < 6) {
        appendCloneSet();
        refreshLoopMetrics();
        clonePasses += 1;
      }
    }

    function autoScrollStep(timestamp) {
      if (!lastAutoTimestamp) lastAutoTimestamp = timestamp;
      var delta = Math.min(timestamp - lastAutoTimestamp, 48);
      lastAutoTimestamp = timestamp;

      if (!loopWidth) refreshLoopMetrics();

      if (!isDragging && !document.hidden && loopWidth > 0) {
        position += (autoPixelsPerSecond * delta) / 1000;
        normalizePosition();
        applyTransform();
      }

      autoFrameId = window.requestAnimationFrame(autoScrollStep);
    }

    function startAutoScroll() {
      if (!autoFrameId) autoFrameId = window.requestAnimationFrame(autoScrollStep);
    }

    function stopAutoScroll() {
      if (!autoFrameId) return;
      window.cancelAnimationFrame(autoFrameId);
      autoFrameId = 0;
      lastAutoTimestamp = 0;
    }

    function endDrag(event) {
      if (!isDragging) return;
      if (event && event.pointerId !== dragPointerId) return;
      isDragging = false;
      track.classList.remove('is-dragging');
      try {
        track.releasePointerCapture(dragPointerId);
      } catch (error) {
        /* pointer may already be released */
      }
      normalizePosition();
      applyTransform();
      startAutoScroll();
    }

    function onPointerDown(event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (event.target.closest('[data-plz-gallery-open]')) return;

      isDragging = true;
      dragPointerId = event.pointerId;
      dragStartX = event.clientX;
      dragStartPosition = position;
      track.classList.add('is-dragging');
      track.setPointerCapture(event.pointerId);
      event.preventDefault();
    }

    function onPointerMove(event) {
      if (!isDragging || event.pointerId !== dragPointerId) return;

      position = dragStartPosition - (event.clientX - dragStartX);
      normalizePosition();
      applyTransform();
      event.preventDefault();
    }

    gallery.classList.add('is-autoplay');
    setupInfiniteLoop();

    whenGalleryReady(function () {
      refreshLoopMetrics();
      startAutoScroll();
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopAutoScroll();
      } else {
        startAutoScroll();
      }
    });

    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove);
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });

    window.addEventListener('resize', refreshLoopMetrics);
  }

  function initScrollGallery(gallery, track, slides) {
    var activeIndex = 0;
    var isDragging = false;
    var dragStartX = 0;
    var dragStartScrollLeft = 0;
    var dragPointerId = -1;

    function scrollToIndex(index) {
      var clamped = Math.max(0, Math.min(index, slides.length - 1));
      slides[clamped].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }

    function updateState() {
      var trackLeft = track.getBoundingClientRect().left;
      var closestIndex = 0;
      var closestDistance = Infinity;

      slides.forEach(function (slide, index) {
        var distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      activeIndex = closestIndex;
    }

    function endDrag(event) {
      if (!isDragging) return;
      if (event && event.pointerId !== dragPointerId) return;
      isDragging = false;
      track.classList.remove('is-dragging');
      try {
        track.releasePointerCapture(dragPointerId);
      } catch (error) {
        /* pointer may already be released */
      }
    }

    function onPointerDown(event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (event.target.closest('[data-plz-gallery-open]')) return;
      if (track.scrollWidth <= track.clientWidth) return;

      isDragging = true;
      dragPointerId = event.pointerId;
      dragStartX = event.clientX;
      dragStartScrollLeft = track.scrollLeft;
      track.classList.add('is-dragging');
      track.setPointerCapture(event.pointerId);
      event.preventDefault();
    }

    function onPointerMove(event) {
      if (!isDragging || event.pointerId !== dragPointerId) return;
      track.scrollLeft = dragStartScrollLeft - (event.clientX - dragStartX);
      event.preventDefault();
    }

    track.addEventListener(
      'scroll',
      function () {
        window.requestAnimationFrame(updateState);
      },
      { passive: true }
    );

    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        scrollToIndex(activeIndex - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        scrollToIndex(activeIndex + 1);
      }
    });

    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove);
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });

    updateState();
  }

  function initInstallmentTerms(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-plz-installment-terms]').forEach(function (wrap) {
      if (wrap.dataset.plzInstallmentInit) return;
      wrap.dataset.plzInstallmentInit = 'true';

      var terms = wrap.querySelector('shopify-payment-terms');
      if (!terms) return;

      var done = false;

      function markReady() {
        if (done) return;
        var rootNode = terms.shadowRoot;
        var text = rootNode && rootNode.textContent ? rootNode.textContent.replace(/\s+/g, ' ').trim() : '';
        if (!text) return;
        done = true;
        wrap.classList.add('is-ready');
        var fallback = wrap.querySelector('[data-plz-installment-fallback]');
        if (fallback) fallback.setAttribute('aria-hidden', 'true');
      }

      var poll = window.setInterval(markReady, 100);
      window.setTimeout(function () {
        window.clearInterval(poll);
      }, 10000);

      if (window.customElements && customElements.whenDefined) {
        customElements.whenDefined('shopify-payment-terms').then(markReady);
      }
      markReady();
    });
  }

  function initGallery() {
    initGalleryIn(document);
  }

  window.plzShopSwitchPlan = switchPlan;
  window.plzShopChangeQty = changeQty;

  function boot() {
    initPlanToggles();
    initQtyButtons();
    initWhySubscribeAccordion();
    initOnceNudge();
    initInstallmentTerms();
    initGallery();
    if (window.plzGalleryLightboxInit) window.plzGalleryLightboxInit(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initGalleryIn(event.target);
    initWhySubscribeAccordion();
    initOnceNudge();
    initInstallmentTerms(event.target);
    if (window.plzGalleryLightboxInit) window.plzGalleryLightboxInit(event.target);
  });
})();
